import { ComingSoon } from "@/components/blocks/ComingSoon";
import { ROUTE_WAITLIST } from "@/lib/brand";
import { STATUS_LAUNCH } from "@/lib/status";

export default function Login() {
  return (
    <ComingSoon
      eyebrow="Login"
      title="Login"
      tagline={`Öffnet ${STATUS_LAUNCH.in}`}
      description="Hier meldet ihr euch später bei MatchGate an, als Verein oder Unternehmen. Bis zum Start könnt ihr euch auf der Warteliste einen Platz vormerken, dann erfahrt ihr als Erste, wann es losgeht."
      primary={{ label: "Platz vormerken", to: ROUTE_WAITLIST }}
      secondary={{ label: "Zur Startseite", to: "/" }}
    />
  );
}
